module.exports = __webpack_public_path__ + "static/media/Third-Digital-Mattress-Tag.bf52f24c.jpg";